import defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.online/httpdocs/~/i18next/~/@babel/runtime/helpers/esm/objectSpread.js
// module id = 674
// module chunks = 0